import React from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";

export function CommonInputField({
  value,
  formik,
  onChange,
  onBlur,
  name,
  style,
  type,
  isPercentage,
  ...props
}) {
  function isBetween0And100(number) {
    return number >= 0 && number <= 100;
  }
  return (
    <>
      <InputText
        id="in"
        style={{ width: "100%", marginTop: "7px", ...style }}
        aria-describedby="email-help"
        className={`selectAgency ${
          formik && formik.touched[name] && formik.errors[name]
            ? "p-invalid"
            : ""
        }`}
        onChange={(e) => {
          if (e.target.value >= 0 || type !== "number") {
            if (isPercentage && !isBetween0And100(e.target.value)) {
              return;
            }
            formik && formik.handleChange(e)
              ? formik.handleChange(e)
              : onChange && onChange(e);
          }
        }}
        type={type && type}
        value={formik ? formik.values[name] : value}
        name={name}
        {...props}
      />
      {formik && formik.touched[name] && Boolean(formik.errors[name]) ? (
        <small id="email-help" className="p-error block">
          {formik.errors[name]}
        </small>
      ) : null}
    </>
  );
}

export function CommonDropdown({
  optionArray,
  optionLabel,
  optionKey,
  value,
  formik,
  onChange,
  onBlur,
  name,
  style,
  label,
  isSelectAll,
  formikChange,
  selectedAllValue,
  ...props
}) {
  return (
    <>
      <select
        name={name}
        id="selectAgency"
        className={`selectAgency ${
          formik && formik.touched[name] && formik.errors[name]
            ? "p-invalid"
            : ""
        }`}
        onChange={
          formik ? formikChange || formik.handleChange : onChange && onChange
        }
        style={{
          width: "100%",
          height: "43px",
          ...style,
        }}
        value={formik ? formik.values[name] : value}
        {...props}
      >
        {optionArray && optionArray?.length === 0 && (
          <option value="" disabled selected>
            No Data available
          </option>
        )}
        <option value="" disabled selected hidden>
          {label}
        </option>
        {isSelectAll && (
          <option value={selectedAllValue || ""}>Select All</option>
        )}
        {optionArray &&
          optionArray?.length > 0 &&
          optionArray?.map((singleOption) => (
            <option value={singleOption[optionKey]}>
              {singleOption[optionLabel]}
            </option>
          ))}
      </select>
      {formik && formik.touched[name] && Boolean(formik.errors[name]) ? (
        <small id="email-help" className="p-error block">
          {formik.errors[name]}
        </small>
      ) : null}
    </>
  );
}

export function PrimeDropDown({
  optionArray,
  optionLabel,
  value,
  onChange,
  name,
  style,
  ...props
}) {
  return (
    <Dropdown
      name={name}
      value={value}
      id="customDropdownId"
      style={{
        backgroundColor: "#1C9894",
        color: "white",
        maxHeight: "45px",
        zIndex: "0",
        ...style,
      }}
      optionLabel={optionLabel}
      options={optionArray}
      onChange={onChange}
      {...props}
    />
  );
}

export function CommonDate({
  value,
  formik,
  onChange,
  onBlur,
  name,
  style,
  label,
  noMaxDate,
  isNew,
  ...props
}) {
  return (
    <>
      <Calendar
        // inputId="name"
        className={`${
          formik && formik.touched[name] && formik.errors[name]
            ? "p-invalid"
            : ""
        }`}
        name={name}
        placeholder={moment().format("MM/DD/YYYY")}
        dateFormat={"mm/dd/yy"}
        value={
          formik
            ? isNew
              ? formik.values[name]
              : moment(formik.values[name]).toDate()
            : value
        }
        onChange={
          formik && formik.handleChange
            ? formik.handleChange
            : onChange && onChange
        }
        showIcon
        maxDate={!noMaxDate && new Date()}
        {...props}
        style={{
          width: "100%",
          height: "43px",
          ...style,
        }}
        readOnlyInput
      />
      {formik && formik.touched[name] && Boolean(formik.errors[name]) ? (
        <small id="email-help" className="p-error block">
          {formik.errors[name]}
        </small>
      ) : null}
    </>
  );
}
